__turbopack_context__.v({
  "skeleton": "DJEmYa_skeleton",
  "skeleton--hidden": "DJEmYa_skeleton--hidden",
  "skeleton__avatar": "DJEmYa_skeleton__avatar",
  "skeleton__footer": "DJEmYa_skeleton__footer",
  "skeleton__header": "DJEmYa_skeleton__header",
  "skeleton__header-text": "DJEmYa_skeleton__header-text",
  "skeleton__input": "DJEmYa_skeleton__input",
  "skeleton__name": "DJEmYa_skeleton__name",
  "skeleton__send": "DJEmYa_skeleton__send",
  "skeleton__status": "DJEmYa_skeleton__status",
});
